import React from 'react';
import { withStyles, Grid, ButtonBase } from '@material-ui/core';
import { withRouter } from "react-router-dom"
import AppUtils from '../../control/apputlis';
import Apis from '../../network/Apis';
import { NewsItem } from './view';
import { ListView } from 'antd-mobile';
import './home.css'
import Swiper from 'react-id-swiper';
import AppData from '../../model/AppData';
import AppConfig from '../../control/config';
import ToName from '../../control/ToName';

//球圈
const ICON_GIF = require("../../images/bg/ballLoad.gif");
const ICON_jin = require("../../images/icons/#@3x.png");
const ICON_dianzan = require("../../images/icons/dianzan_icon@3x.png");
const ICON_dianzan_sel = require("../../images/icons/dianzan2_icon@3x.png");
const ICON_Hot = require("../../images/icons/HOT@3x.png");
const ICON_pl = require("../../images/icons/pinglun_icon@3x.png");

class HomeCircle extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            dataList: [],
            isRequire: false,
            pageSize: 20,
            pageNum: 1,
            totalPage: 0,
            bannerDatas: [],
            hotList: [],
            showComments:false //显示评论
        }
        this.params = {
            slidesPerView: 'auto',
            spaceBetween: 20,
            direction: 'horizontal',
            loop: true,
            centeredSlides: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,

            }
        };
    }


    componentDidMount() {
        // this.getNewsList(true);
        this.getData()
        this.getServerConfig()
    }
    getServerConfig = async () => {
        let res = await Apis.encryptionServerConfig();
        if (res.code == 200 && res.data) {
            let showComments = res.data.ball_news_comment == '1' ? true : false
            this.setState({
                showComments: showComments,
            })
        }
        
    }

    componentWillUnmount() {
        this.setState = () => false;
    }
    getData = async (isRequire = false) => {
        const { pageSize, pageNum, dataList, bannerDatas, hotList } = this.state;


        let customer_id = AppData.me.customer_id;
        let token = AppData.me.token;
        let channel = AppConfig.channelid;
        let result = await Apis.encryptionCircleHome(customer_id, token, channel, pageNum);
        if (result.code == 200) {
            let list = result.data.list;

            for (let i = 0; i < list.length; i++) {
                let item = list[i];

                dataList.push(item)
            }
            if (result.data.banner_list.length > 0) {
                this.setState({ isRequire: true, bannerDatas: result.data.banner_list, hotList: result.data.hot_list, dataList: dataList });
            } else {
                this.setState({ isRequire: true, dataList: dataList });
            }


        }
    }


    _onClickNews = (data) => {
        // const { data } = this.props;
        this.props.history.push({ pathname: '/newsdetail/' + data.id, data: data });
    }

    _onEndReached = () => {
        // console.log("到底了");
        this.state.pageNum++;
        this.getData();
    }



    _renderHeader = () => {
        const { bannerDatas, hotList } = this.state;
        const { classes } = this.props;
        return <Grid container style={{ width: '100vm', overflow: 'hidden', }}>
            <div className='circleBannerBox'>
                {
                    bannerDatas && bannerDatas.length > 0 && <Swiper {...this.params}  >
                        {
                            bannerDatas.map((item, i) => (
                                <ButtonBase onClick={() => this.toDelite(item.bid)} key={i} className={classes.bannerItem} >
                                    <img src={item.img} className={classes.bannerImg} alt='banner'></img>
                                </ButtonBase>
                            ))
                        }

                    </Swiper>
                }
            </div>
            {/* 今日热门 */}
            {hotList.length > 3 &&
                <Grid  container style={{ width: '100vm', overflow: 'hidden', }}>
                    <div style={{ display: 'flex', marginTop: 15 }}>
                        <img style={{ marginLeft: 10, width: 30, height: 15 }} src={ICON_Hot} />
                        <div style={{ color: '#919191', fontSize: 12, marginLeft: 10 }}>今日热门</div>
                    </div>
                    <div className='circleHotBox'>
                        <div className='circleHotList'>
                            <div onClick={() => this.toDelite(hotList[0].bid)}>{hotList[0].title}</div>
                            <div onClick={() => this.toDelite(hotList[1].bid)} style={{ marginTop: 10 }}>{hotList[1].title}</div>
                        </div>
                        <div style={{ width: 1, height: 50, backgroundColor: '#E2E2E2' }}></div>
                        <div className='circleHotList'>
                            <div onClick={() => this.toDelite(hotList[2].bid)}>{hotList[2].title}</div>
                            <div onClick={() => this.toDelite(hotList[3].bid)} style={{ marginTop: 10 }}>{hotList[3].title}</div>
                        </div>
                        <div></div>
                    </div>
                </Grid>
            }
        </Grid>
    }

    toDelite = (id) => {
        if (id == 0) {
            return;
        }

        let os = 0;
        if (AppData.os !== '') {
            os = AppData.os
        }
        let token = 0;

        if (AppData.me.token !== '') {
            token = AppData.me.token
        }

        let customerId = 0
        if (AppData.me.customer_id && AppData.me.customer_id != 0 && AppData.me.customer_id != '') {
            customerId = AppData.me.customer_id
        } 
        
        // id/:os/:token/:customerId
        ToName(this.props,`/circleDel/${id}/${os}/${token}/${customerId}`)
    }

    //点赞
    toZan = async (id, zanType) => {
        if (!AppData.me.isLogin()) {
            ToName(this.props,'/login')
            // this.props.history.push({ pathname: '/login' });
            return;
        }

        let customer_id = AppData.me.customer_id;
        let token = AppData.me.token;
        let channel = AppConfig.channelid;
        let result = await Apis.encryptionCircleZan(customer_id, token, channel, id, 1, zanType);
        if (result.code == 200) {
            console.log(result);
            let list = this.state.dataList;
            for (let i = 0; i < list.length; i++) {
                let item = list[i];
                if (item.id == id) {
                    item.is_zan = item.is_zan == 1 ? 0 : 1
                    if (item.is_zan == 1) {
                        item.zan++;
                    } else {

                        item.zan--;
                    }
                }


            }
            this.setState({ dataList: list })

        }

    }

    _renderItem = (data) => {
        const { classes } = this.props;
        return (
            <Grid container style={{ width: '100vm', overflow: 'hidden', }}>
                <div className='circleItemBox'>
                    <div className='circleUser' onClick={() => this.toDelite(data.id)}>
                        <img className='avatar' src={data.head}></img>
                        <div className='right'>
                            <div className='circleUserTitle'>{data.name}</div>
                            <div className='circleUserTime'>{data.time}</div>
                        </div>

                    </div>

                    <div className='circleItemTitle' onClick={() => this.toDelite(data.id)}>
                        {data.title}
                    </div>
 
                    <div className='warpImgBox' onClick={() => this.toDelite(data.id)}>
                        {data.img_list.map((item, i) => {
                            return <img className='itemImg' key={i} src={item}></img>
                        })}
                    </div>

                    <div className='circleItemBoottom'>
                        <div className='left' onClick={() => this.toDelite(data.id)}>
                            <img src={ICON_jin}></img>
                            <div>{data.tag}</div> 
                        </div>
                        {this.state.showComments && <div className='right'>
                            <div onClick={() => this.toZan(data.id, data.is_zan == 0 ? 1 : 0)}>
                                <img src={data.is_zan == 0 ? ICON_dianzan : ICON_dianzan_sel}></img>
                                <span>{data.zan}</span>
                            </div>

                            <div>
                                <img src={ICON_pl} style={{ marginLeft: 10 }}></img>
                                <span>{data.comment_num}</span>
                            </div>


                        </div>}
                    </div>
                </div>
            </Grid>

        );
    }

    _renderFooter = () => {
        return (<Grid style={{ height: 148 }}></Grid>);
    }

    render() {
        const { classes } = this.props;
        const { dataList, isRequire } = this.state;
        let data = dataList;
        const ds = new ListView.DataSource({
            rowHasChanged: (r1, r2) => r1 !== r2
        });

        if (isRequire) {
            return <div className={classes.list}>
                <ListView
                    initialListSize={data.length}
                    style={{ width: '100%', maxWidth: '100%', height: '100%' }}
                    contentContainerStyle={{ width: '100%' }}
                    dataSource={ds.cloneWithRows(data)}
                    renderHeader={this._renderHeader}
                    renderFooter={this._renderFooter}
                    renderRow={this._renderItem}
                    onEndReached={this._onEndReached}

                    useBodyScroll={false}
                    onEndReachedThreshold={0.5}
                />
                {/* {newsList.map((item,i)=>(
                    this._renderItem(item)
                ))} */}

            </div>
        } else {
            return <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', justifyContent: 'center' }}>
                < img src={ICON_GIF} style={{ width: 280, height: 280, marginTop: 150, objectFit: 'scale-down' }}></img>
                {/* <Typography style={{ fontSize: 12, color: '#878787', }} >赛事正在加载中...</Typography> */}
            </div>
        }


    }

}

export default withRouter(withStyles((theme) => ({
    bannerItem: {
        padding: theme.spacing(0, 0, 0, 0),
        width: "calc(100vw)",
        height: 135,
        color: theme.palette.secondary.main,
        borderRadius: 10
    },
    bannerImg: {
        width: "calc(100vw)",
        height: 135,
        objectFit: 'cover',
        borderRadius: 10
        // backgroundColor:'#e6e6e6'
        // borderTopLeftRadius: 10,
        // borderTopRightRadius: 10
    },
    title: {
        color: '#0D0D0D',
        fontSize: 14,
    },
    time: {
        color: '#919191',
        fontSize: 10,
        marginTop: 10,
    },
    itemColumn: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        width: '70%'

    },
    itemView: {
        width: '100%',
        marginBottom: 7,
        marginLeft: 10,
        backgroundColor: '#fff',
        borderRadius: 10,
        display: 'flex',
        justifyContent: 'space-between',
        padding: 10
    },
    list: {
        margin: theme.spacing(0),
        padding: theme.spacing(0),
        height: '100%',
    },
}))(HomeCircle));